<template>
  <v-col
    cols="12"
    lg="4"
    md="4"
    sm="6"
    class="mb-2"
    :class="{
      'fixed-widget-card': isLeftDrawerPanOpen,
      [`smallWidget-${index}`]: true
    }"
  >
    <v-card
      height="140"
      tile
      text
      class="shadow pa-3"
      v-if="widgetInfo.kpiSlug !== 'empty_slug'"
      title="All Time"
    >
      <v-row class="ma-0">
        <v-col cols="9" class="pa-0">
          <v-col class="pa-0" sm="12">
            <v-card-title class="pa-0">
              <div
                class="dashboard-fixed-widget-text-container justify-center align-center"
                v-if="!dataReady"
              >
                <img height="40" src="@/assets/images/loader.svg" />
              </div>
              <div
                class="dashboard-fixed-widget-text-container"
                v-if="dataReady"
              >
                {{ displayValue.toLocaleString() }}
              </div>
            </v-card-title>
          </v-col>
          <v-col sm="12 " class="pa-0">
            <v-card-text class="px-0 py-4">
              <p class="fixed-widget-name" v-if="dateRangeFrom">
                {{ getKPIName }}
              </p>
            </v-card-text>
          </v-col>
        </v-col>
        <v-col class="pa-1" cols="3">
          <!-- <v-btn
            title="Settings is disabled for now"
            icon
            small
            :ripple="false"
            :depressed="true"
            @click.stop="openAddEditWidgetDialog()"
            class="editWidgetBtn"
            absolute
            top
            right
          >
            <v-img
              :src="settingsImgSrc"
              class="settingImageStyle"
              aspect-ratio="1"
            ></v-img>
            <v-icon :color="CLOSE_COLOR">close</v-icon>
          </v-btn> -->
          <img
            v-if="!darkTheme"
            :src="cardSrc"
            alt
            :class="cardProperty('margin')"
            width="80%"
          />
          <img
            v-else
            :src="cardSrc"
            alt
            :class="cardProperty('margin')"
            :height="cardProperty('height')"
          />
        </v-col>
      </v-row>
    </v-card>
    <AddWidget height="140" :widgetInfo="widgetInfo" v-else></AddWidget>
  </v-col>
</template>

<script>
import AddWidget from './AddWidget';
import colors from '@/constants/colors';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import FileSizeConverter from '@/helpers/FileSizeConverter';
import { bytesInKB } from '@/helpers/FileSizeConverter';
export default {
  components: {
    AddWidget
  },
  props: ['index', 'selectedDate', 'isLeftDrawerPanOpen', 'widgetInfo'],
  data() {
    return {
      dateRangeFrom: null,
      dateRangeTo: null,
      iconIndex: -1,
      dataReady: false,
      hasError: false,
      displayValue: null,
      dataStorageUnit: '',
      CLOSE_COLOR: colors.closeDialogBtn,
      tUnit: null,
      date: this.selectedDate,
      darkTheme: null,
      widgets: [],
      widgetIndex: 0,
      configData: null,
      settingsImgSrc: require('@/assets/images/settings-icon.svg'),
      iconMap: {
        user: 0,
        box: 1,
        mail: 2,
        onedrive: 3,
        sharepoint: 4,
        teams: 5,
        dropbox: 6
      },
      cards: [
        {
          title: '',
          count: null,
          src: require('@/assets/images/theme--light/user.svg'),
          srcDark: require('@/assets/images/theme--dark/user.svg'),
          height: '60%',
          margin: 'mt-3',
          dateRangeFrom: null,
          dateRangeTo: null
        },
        {
          title: '',
          count: null,
          src: require('@/assets/images/theme--light/box.svg'),
          srcDark: require('@/assets/images/theme--dark/box.svg'),
          height: '50%',
          margin: 'mt-3',
          dateRangeFrom: null,
          dateRangeTo: null
        },
        {
          title: '',
          count: null,
          src: require('@/assets/images/theme--light/mail.svg'),
          srcDark: require('@/assets/images/theme--dark/mail.svg'),
          height: '50%',
          margin: 'mt-3',
          dateRangeFrom: null,
          dateRangeTo: null
        },
        {
          title: '',
          count: null,
          src: require('@/assets/images/theme--light/onedrive.svg'),
          srcDark: require('@/assets/images/theme--dark/onedrive.svg'),
          height: '50%',
          margin: 'mt-3',
          dateRangeFrom: null,
          dateRangeTo: null
        },
        {
          title: '',
          count: null,
          src: require('@/assets/images/theme--light/sharepoint.svg'),
          srcDark: require('@/assets/images/theme--dark/sharepoint.svg'),
          height: '50%',
          margin: 'mt-3',
          dateRangeFrom: null,
          dateRangeTo: null
        },
        {
          title: '',
          count: null,
          src: require('@/assets/images/theme--light/teams.svg'),
          srcDark: require('@/assets/images/theme--dark/teams.svg'),
          height: '50%',
          margin: 'mt-3',
          dateRangeFrom: null,
          dateRangeTo: null
        },
        {
          title: '',
          count: null,
          src: require('@/assets/images/theme--light/dropbox.svg'),
          srcDark: require('@/assets/images/theme--dark/dropbox.svg'),
          height: '50%',
          margin: 'mt-3',
          dateRangeFrom: null,
          dateRangeTo: null
        }
      ]
    };
  },
  computed: {
    ...mapState({
      widgetUpdateHappened: state => state.dashboard.widgetUpdateHappened
    }),
    cardSrc() {
      if (this.iconIndex !== -1) {
        return this.darkTheme
          ? this.cards[this.iconIndex].srcDark
          : this.cards[this.iconIndex].src;
      }
      return null;
    },
    getKPIName() {
      return `${this.widgetInfo.kpiIdName} ${this.dataStorageUnit &&
        'in ' + this.dataStorageUnit}`;
    }
  },
  watch: {
    // eslint-disable-next-line
    selectedDate(newValue, oldValue) {
      this.dataReady = false;
      this.getCardData();
    },
    // eslint-disable-next-line
    widgetUpdateHappened(newValue, oldValue) {
      if (!newValue) {
        return false;
      }
      let selectedWidgetInfo = this.getSelectedwidgetForEdit();
      if (!selectedWidgetInfo) {
        return false;
      }
      if (this.widgetInfo.id === selectedWidgetInfo.id) {
        // yahi wala card hai
        this.dataReady = false;
        this.getCardData();
      }
    }
  },
  created() {},

  methods: {
    ...mapMutations('dashboard', [
      'toggleAddEditModal',
      'setSelectedForEdit',
      'setWidgetData'
    ]),
    ...mapActions('dashboard', ['dialog']),
    ...mapGetters('dashboard', [
      'getKpiDetails',
      'getWidgetList',
      'getSelectedwidgetForEdit',
      'getWidgetData',
      'getCurrentOrgFetchedData'
    ]),
    cardProperty(property) {
      if (this.iconIndex !== -1) {
        return this.cards[this.iconIndex][property];
      }
      return null;
    },
    openAddEditWidgetDialog() {
      this.toUpdate = false;
      this.setSelectedForEdit(this.widgetInfo);
      this.toggleAddEditModal(true);
    },
    async getCardData() {
      this.hasError = false;
      if (this.widgetInfo.kpiSlug === 'empty_slug') {
        // this is an empty card; no need to fetch any data
        return false;
      }

      this.displayValue = '';

      let kpiDetails = this.getKpiDetails();

      let currentKpi = kpiDetails.find(element => {
        return element.slug === this.widgetInfo.kpiSlug;
      });

      // need to check if this is an empty card
      if (currentKpi !== undefined) {
        this.iconIndex = this.iconMap[currentKpi.insetImageType];
        let paramArr = [];
        if (currentKpi.params) {
          currentKpi.params.forEach(param => {
            if (param.name === 'org_id') {
              paramArr.push({
                index: param.index,
                value: this.orgId
              });
            }
          });
          let urls = {
            email_volume: '/email/volume/v1/',
            email_total_legitimate: '/email/count/v1/'
          };

          try {
            let url =
              this.getServiceURL('baseUrlForAnalyticsService') +
              '/kpi/elastic/slug/' +
              this.currentlySelectedOrgId +
              '/' +
              this.widgetInfo.kpiSlug +
              '?tillDate=' +
              this.computeUTCTimestamp(this.selectedDate) +
              '&timeUnit=' +
              this.widgetInfo.timeUnit;
            if (
              (this.widgetInfo.kpiSlug === 'email_volume' ||
                this.widgetInfo.kpiSlug === 'email_total_legitimate') &&
              this.isCurrentOrgLegacy
            ) {
              url = `${this.getServiceURL('searchService')}${
                urls[this.widgetInfo.kpiSlug]
              }${this.currentlySelectedOrgId}`;
            }
            let response;
            if (urls[this.widgetInfo.kpiSlug]) {
              if (this.isCurrentOrgLegacy) {
                response = await this.axios.get(url);
              } else {
                response = await this.axios.post(url, {
                  validatedList: paramArr
                });
              }
              response.data.body = response?.data?.body;
            } else {
              response = await this.axios.post(url, {
                validatedList: paramArr
              });
            }
            if (response.data && response.data.body) {
              let widgetData = this.getWidgetData();
              widgetData[this.widgetInfo.id] = response.data.body;

              this.processResponse(response.data.body);
            } else {
              this.snackbar('error', this.$message.ERROR_LOADING_DATA);
            }
          } catch (err) {
            this.snackbar('error', err);
          }
        }
      } else {
        // this.snackbar('error', this.$message.KPI_NOT_FOUND);
      }
    },
    updateDateRanges() {
      let dates = this.setDateRange(
        this.widgetInfo.timeUnit,
        this.selectedDate
      );
      this.dateRangeFrom = dates[0] || null;
      this.dateRangeTo = dates[1] || null;
    },
    processResponse(response) {
      this.updateDateRanges();
      let kpiDetails = this.getKpiDetails();

      let currentKpi = kpiDetails.find(element => {
        return element.slug === this.widgetInfo.kpiSlug;
      });
      if (currentKpi === undefined) {
        return;
      }
      if (this.iconIndex === -1) {
        this.iconIndex = this.iconMap[currentKpi.insetImageType];
      }
      // push headers
      let allKeysWithoutTime = [];
      (currentKpi?.columns || []).forEach(item => {
        if (item.alias !== 'time_unit') {
          allKeysWithoutTime.push(item.alias);
        }
      });

      let firstValue = 0;
      let secondValue = 0;

      if (allKeysWithoutTime.length === 1) {
        // just add and display
        if (currentKpi.rollOverType) {
          firstValue = response[0][allKeysWithoutTime[0]];
        } else {
          response.forEach(row => {
            firstValue += parseFloat(row[allKeysWithoutTime[0]], 10);
          });
        }
        // To check if data coming is storage type like in MB then only use FileSizeConverter else no conversion
        if (this.widgetInfo?.isStorageTypeData) {
          // conversion of data coming from BE which is in KB to bytes by multiplying 1024 (bytesInKB)
          const { size, unit } = FileSizeConverter(
            firstValue * bytesInKB,
            'object'
          );
          this.displayValue = size;
          this.dataStorageUnit = unit || '';
        } else {
          this.displayValue = firstValue;
          this.dataStorageUnit = '';
        }
      }
      // eslint-disable-next-line
      if (allKeysWithoutTime.length === 2) {
        if (currentKpi.rollOverType) {
          firstValue = response[0][allKeysWithoutTime[0]];
          secondValue = response[0][allKeysWithoutTime[1]];
        } else {
          // just add and display
          response.forEach(row => {
            firstValue += parseFloat(row[allKeysWithoutTime[0]], 10);
            secondValue += parseFloat(row[allKeysWithoutTime[1]], 10);
          });
        }
        this.displayValue = firstValue + '/' + secondValue;
      }
      this.dataReady = true;
    }
  },
  mounted() {
    let theme = localStorage.getItem('selectedTheme');
    this.darkTheme = theme === 'Dark' ? true : false;
    const allWidgetData = this.getWidgetData();
    if (
      allWidgetData[this.widgetInfo.id] !== undefined &&
      this.getCurrentOrgFetchedData().date === this.selectedDate
    ) {
      this.processResponse(allWidgetData[this.widgetInfo.id]);
    } else {
      this.dateRangeFrom = null;
      this.dateRangeTo = null;
      this.getCardData();
    }
  }
};
</script>

<style scoped>
.fix-height {
  height: 65px;
}
.v-card__title {
  font-size: 24px;
  font-weight: 800;
}
.dashboard-fixed-widget-text-container {
  height: 40px;
}
.fixed-widget-name {
  font-size: 12px;
}
</style>
